module.exports = __webpack_public_path__ + "img/65.4.NH3-N.5cfe7f7f.png";